import { axiosInstance } from "@helpers/axios-instance";
import type { StrategicGuide, DataAwareResponse } from "../types/types";
import { useQueryWithValidation } from "./useQueryWithValidation";

export function useStrategicGuide(householdExternalCode: string) {
  return useQueryWithValidation({
    queryKey: ["strategic-guide", householdExternalCode],
    queryFn: async () => {
      const data = await axiosInstance({
        method: "GET",
        url:  `Salesforce/StrategicGuide/${householdExternalCode}`,
      });
      return data.data as DataAwareResponse<StrategicGuide>;
    },
    enabled: !!householdExternalCode,
  });
}
